// extracted by mini-css-extract-plugin
export default {"wrapper":"Social_wrapper__nsECV","title":"Social_title__eP7Sk","links":"Social_links__j-Tum","link":"Social_link__aDn-p"};